'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var predicates = require('./predicates.js');



exports.isEmpty = predicates.isEmpty;
exports.isEmptyString = predicates.isEmptyString;
exports.isNumericString = predicates.isNumericString;
exports.isPositiveIntegerString = predicates.isPositiveIntegerString;
exports.isPositiveNumericString = predicates.isPositiveNumericString;
exports.lengthLessThan = predicates.lengthLessThan;
exports.lengthMoreThan = predicates.lengthMoreThan;
exports.notEmpty = predicates.notEmpty;
exports.notEmptyString = predicates.notEmptyString;
exports.notNumericString = predicates.notNumericString;
